import Vue from 'vue'

export const namespaced = true

export const state = {
    bills: [],
    clientBills: [],
    bill: {},
    total: 0,
    page: 1,
    limit: 10,
    billsCount: 0,
    billsLoading: false,
    billLoading: false
}

//MUTATIONS are synchronous : mutate / update state => this.$store.commit('ADD_EVENT')
export const mutations = {

    SET_BILLS_LIST(state, bills) {
        // console.log(bills)
        state.bills = bills
    },

    SET_CLIENT_BILLS_LIST(state, bills) {
        // console.log(bills)
        state.clientBills = bills
    },

    SET_BILL(state, bill) {
        state.bill = bill
    },

    SET_BILLS_TOTAL(state, total) {
        state.total = total
    },

    SET_BILLS_COUNT(state, count) {
        state.billsCount = count
    },

    SET_BILLS_LOADING(state, loading) {
        state.billsLoading = loading
    },

    SET_BILL_LOADING(state, loading) {
        state.billLoading = loading
    }
}

//ACTIONS are assynchronous : actions fetch datas (AJAX) then send results to mutations (to update local state)  => this.$store.dispatch('createEvent')
export const actions = {

    getClientBills({commit, dispatch}, {id, page, limit}) {
        commit('SET_BILLS_LOADING', true)
        //check values or take default
        page = page ? page : state.page
        limit = limit ? limit : state.limit

        return Vue.axios.get(`/debiteurs/${id}/bills?page=${page}&limit=${limit}`)
            .then(response => {
                commit('SET_BILLS_LIST', response.data)
                commit('SET_BILLS_TOTAL', response.headers['x-total-count'])
                commit('SET_BILLS_LOADING', false)
            })
            .catch(error => {
                commit('SET_BILLS_LOADING', false)
                const nofitication = {
                    type: 'danger',
                    message: `Erreur de chargement des factures : ${(error.response && error.response.data.error) ? error.response.data.error : error.message}`
                }
                dispatch('notification/add', nofitication, {root: true})
            })
    },

    getAllBills({commit, dispatch}, {page, limit,solded = null}) {
        commit('SET_BILLS_LOADING', true)
        //check values or take default
        page = page ? page : state.page
        limit = limit ? limit : state.limit

        return Vue.axios.get(`/bills?page=${page}&limit=${limit}&solded=${solded}`)
            .then(response => {
                commit('SET_BILLS_LIST', response.data)
                commit('SET_BILLS_TOTAL', response.headers['x-total-count'])
                commit('SET_BILLS_LOADING', false)
            })
            .catch(error => {
                commit('SET_BILLS_LOADING', false)
                dispatch('displayError', {message: 'Erreur de chargement des factures', error}, {root: true})
            })
    },

    getAllClientBills({commit, dispatch}, {idclient}) {
        commit('SET_BILLS_LOADING', true)

        return Vue.axios.get(`/bills/destinataire/${idclient}`)
            .then(response => {
                commit('SET_CLIENT_BILLS_LIST', response.data)
                commit('SET_BILLS_LOADING', false)
            })
            .catch(error => {
                commit('SET_BILLS_LOADING', false)
                dispatch('displayError', {
                    message: 'Erreur de chargement des factures du destinataire',
                    error
                }, {root: true})
            })
    },

    getBill({commit, dispatch}, id) {
        commit('SET_BILL_LOADING', true)
        return Vue.axios.get(`/bills/${id}`)
            .then(response => {
                commit('SET_BILL', response.data)
                commit('SET_BILL_LOADING', false)
            })
            .catch(error => {
                commit('SET_BILL_LOADING', false)
                dispatch('displayError', {message: 'Erreur de chargement de la facture', error}, {root: true})
            })
    },

    getBillCount({commit, dispatch}) {

        return Vue.axios.get('/bills/count')
            .then(response => {
                commit('SET_BILLS_COUNT', response.data)
            })
            .catch(error => {
                dispatch('displayError', {message: 'Erreur de chargement du compteur de facture', error}, {root: true})
            })
    },

    saveBill({commit, dispatch}, bill) {
        commit('SET_BILL_LOADING', true)
        if (!bill.id || bill.id === -1) {
            return Vue.axios.post('/bills', bill)
                .then(() => {
                    commit('SET_BILL_LOADING', false)
                    dispatch('displaySuccess', 'Facture créée', {root: true})
                })
                .catch(error => {
                    commit('SET_BILL_LOADING', false)
                    dispatch('displayError', {message: 'Erreur lors de la création de facture', error}, {root: true})
                    throw error
                })
        } else {
            return Vue.axios.put(`/bills/${bill.id}`, bill)
                .then(() => {
                    commit('SET_BILL_LOADING', false)
                    dispatch('displaySuccess', 'Facture mise à jour', {root: true})
                })
                .catch(error => {
                    commit('SET_BILL_LOADING', false)
                    dispatch('displayError', {message: 'Erreur de modification de facture', error}, {root: true})
                    throw error
                })
        }
    },
    addCommentToBill({commit, dispatch}, {id, comment}) {
        commit('SET_BILL_LOADING', true)
        return Vue.axios.post(`/bills/${id}/comment`, {comment: comment})
            .then(() => {
                commit('SET_BILL_LOADING', false)
                dispatch('displaySuccess', 'Commentaire ajouté', {root: true})
            })
            .catch(error => {
                commit('SET_BILL_LOADING', false)
                dispatch('displayError', {message: 'Erreur lors de l\'ajout du commentaire', error}, {root: true})
                throw error
            })
    },
    addReglementToBill({commit, dispatch}, {id, reglement}) {
        commit('SET_BILL_LOADING', true)
        return Vue.axios.post(`/bills/${id}/payment`, reglement)
            .then(() => {
                commit('SET_BILL_LOADING', false)
                dispatch('displaySuccess', 'Règlement ajouté', {root: true})
            })
            .catch(error => {
                commit('SET_BILL_LOADING', false)
                dispatch('displayError', {message: 'Erreur lors de l\'ajout du règlement', error}, {root: true})
                throw error
            })
    },
    deleteBill({commit, dispatch}, id) {
        commit('SET_BILL_LOADING', true)
        return Vue.axios.delete(`/bills/${id}`)
            .then(() => {
                commit('SET_BILL', {})
                commit('SET_BILL_LOADING', false)
                dispatch('displaySuccess', 'Facture supprimée', {root: true})
            })
            .catch(error => {
                commit('SET_BILL_LOADING', false)
                dispatch('displayError', {message: 'Erreur de suppression de facture', error}, {root: true})
            })
    }
}

//GETTERS Returns current state objects with logic/filter functions
export const getters = {
    billsOrderByDateEmission: state => {
        return state.bills.slice().sort((a, b) => new Date(b.dateEmission).getTime() - new Date(a.dateEmission).getTime())
    },
    billsOrderByDateEcheance: state => {
        return state.bills.slice().sort((a, b) => new Date(b.dateEcheance).getTime() - new Date(a.dateEcheance).getTime())
    }
}
